export type VerifiedContactMethod = "email" | "phone";

export const WHOOSH_TERMS_URL = "https://www.whoosh.io/terms";
export const WHOOSH_PRIVACY_URL = "https://www.whoosh.io/privacy";

type LegalDisclaimerContent = {
  introductoryText: string;
  detailText: string;
};

export const getAccountCreationLegalDisclaimerContent = (
  verifiedContactMethod: VerifiedContactMethod
): LegalDisclaimerContent => {
  if (verifiedContactMethod === "phone") {
    return {
      introductoryText:
        "By providing your mobile number and clicking continue you agree to the",
      detailText:
        "and your mobile number will be used for 2-Factor Authentication. You may receive SMS notifications with updates on your booking from us but can opt out anytime.",
    };
  }

  return {
    introductoryText:
      "By providing your email and clicking continue you agree to the",
    detailText:
      "You may receive email notifications with updates on your booking from us but can opt out anytime.",
  };
};
